import { Bookmark } from 'lucide-react'

interface BookmarkToggleProps {
  saved: boolean
  pending?: boolean
  onToggle: () => void
}

/**
 * Compact save/unsave icon button for article rows. Stops propagation so it
 * can be docked inside a row that's otherwise wrapped in a Link to the article.
 */
export function BookmarkToggle({ saved, pending, onToggle }: BookmarkToggleProps) {
  return (
    <button
      type="button"
      aria-pressed={saved}
      aria-label={saved ? 'Remove from saved articles' : 'Save article'}
      disabled={pending}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onToggle()
      }}
      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-line bg-canvas text-fg-secondary transition-colors hover:border-line-strong hover:text-fg disabled:cursor-not-allowed disabled:opacity-50"
    >
      <Bookmark size={14} fill={saved ? 'currentColor' : 'none'} aria-hidden="true" />
    </button>
  )
}
